import { createSelector } from 'reselect';

const listingSelector = state => state.listing;

// LISTINGS
export const listings = createSelector(listingSelector, state => state.listings);
export const current = createSelector(listingSelector, state => state.current);
export const typeOptions = createSelector(listingSelector, state => state.typeOptions);
export const activePage = createSelector(listingSelector, state => state.activePage);
export const count = createSelector(listingSelector, state => state.count);
export const pages = createSelector(listingSelector, state => state.pages);
export const query = createSelector(listingSelector, state => state.query);
export const view = createSelector(listingSelector, state => state.view);
